<template>
  <div class="vvip-wrap">
    <div class="vvip-frame">
      <template v-if="bVipList.length === 0">
        <div class="vvip-container">
          <div v-for="(vip, index) in aVipList" :key="index" :class="{'vvip-card': true, 'active': vip.level_name === currentVipName}">
            <div v-if="rebateInfo && rebateInfo.length > 0" class="card-lv-title">
              {{ rebateInfo[index+1][0] }}
            </div>
            <div class="card-pic">
              <img :src="vip.image_big" alt="">
            </div>
            <div v-if="tableData && tableData.length > 0" class="card-section">
              <div class="section-title">
                <i class="fa-solid fa-arrow-trend-up" aria-hidden="true" />
                {{ $t("Bao.vip_promotion_criteria") }}
              </div>
              <div v-if="tableData[2]" class="section-row">
                <div> {{ $t(tableData[2].label) }}</div>
                <div v-if="vip[`${tableData[2].key}_text_enable`]">
                  {{ vip[`${tableData[2].key}_text`] }}
                </div>
                <div v-else>
                  {{ formatNumber(vip[tableData[2].key]) }}
                </div>
              </div>
              <div v-if="tableData[3]" class="section-row">
                <div>{{ $t(tableData[3].label) }}</div>
                <div v-if="vip[`${tableData[3].key}_text_enable`]">
                  {{ vip[`${tableData[3].key}_text`] }}
                </div>
                <div v-else>
                  {{ formatNumber(vip[tableData[3].key]) }}
                </div>
              </div>
            </div>
            <div v-if="tableData && tableData.length > 0" class="card-section">
              <div class="section-title">
                <i class="fa-solid fa-gift" aria-hidden="true" />
                {{ $t("Bao.vip_exclusive_bonus") }}
              </div>
              <div v-if="tableData[0]" class="section-row">
                <div>{{ $t(tableData[0].label) }}</div>
                <div v-if="vip[`${tableData[0].key}_text_enable`]">
                  {{ vip[`${tableData[0].key}_text`] }}
                </div>
                <div v-else>
                  {{ formatNumber(vip[tableData[0].key]) }}
                </div>
              </div>
              <div v-if="themeConfig.showVipContent && tableData[1]" class="section-row">
                <div>{{ $t(tableData[1].label) }}</div>
                <div v-if="vip[`${tableData[1].key}_text_enable`]">
                  {{ vip[`${tableData[1].key}_text`] }}
                </div>
                <div v-else>
                  {{ formatNumber(vip[tableData[1].key]) }}
                </div>
              </div>
              <div v-if="tableData[4]" class="section-row">
                <div>{{ $t(tableData[4].label) }}</div>
                <div v-if="vip[`${tableData[4].key}_text_enable`]">
                  {{ vip[`${tableData[4].key}_text`] }}
                </div>
                <div v-else>
                  {{ vip[tableData[4].key] }}
                </div>
              </div>
            </div>
            <div v-if="vip.rebate_text && vip.rebate_text.length > 0 && tableData.length > 0" class="card-section">
              <div class="section-title">
                <i class="fa-solid fa-coins" aria-hidden="true" />
                {{ $t("Bao.vip_rebate") }}
              </div>
              <table class="game-table">
                <thead>
                  <tr>
                    <th class="col-cat">
                      {{ $t("Bao.vip_game_category") }}
                    </th>
                    <th class="col-rate">
                      {{ $t("Bao.vip_rebate") }}
                    </th>
                    <th v-if="hasDailyMaxWin(vip)" class="col-rate">
                      {{ $t("Bao.vip_max_daily_win") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="rebate in vip.rebate_text.filter(item => item.enable === 1)"
                    :key="rebate.game_type_id"
                  >
                    <td class="cat-name">
                      {{ rebate.game_type_name }}
                    </td>
                    <td class="rate-value">
                      {{ formatRebateText(rebate.text) }}
                    </td>
                    <td v-if="hasDailyMaxWin(vip)" class="rate-value">
                      {{ getDailyMaxWinText(vip, rebate.game_type_id) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- eslint-disable-next-line -->
        <div class="describe-frame" v-html="vipRule"></div>
      </template>

      <!-- ========= 階段型 VIP  ========= -->
      <div v-else class="vip2-wrap">
        <!-- 目前等級：我的 VIP 進度 -->
        <div v-if="token" class="vip2-my-progress">
          <div class="mp-badge">
            <i class="fa-solid" :class="trackIcon(currentStagedTierIndex)" aria-hidden="true" />
          </div>
          <div class="mp-body">
            <div class="mp-head">
              <span class="mp-current">{{ $t('Bao.current_level') }} <b>{{ vipInfo.currentVipName }}</b></span>
            </div>
            <div class="mp-bar">
              <span class="mp-bar-fill" :style="{ width: upgrade_performance_percentage + '%' }" />
            </div>
            <div class="mp-foot">
              <span>{{ $t('Bao.short_of') }} {{ cumulative_flow }}</span>
            </div>
          </div>
        </div>

        <div class="vip2-plan">
          <div class="vip2-head">
            <h1 class="vip2-page-title">
              {{ $t('Bao.vip_plan') }}
            </h1>
            <p class="vip2-page-sub">
              {{ $t('Bao.vip_plan_desc') }}
            </p>
          </div>

          <div class="vip2-track">
            <div class="vip2-track-inner">
              <div
                v-for="(vip, index) in bVipList"
                :key="vip.id || index"
                class="vip2-node"
                :class="`tg-${trackTierGroup(index, bVipList.length)}`"
              >
                <div class="node-dot">
                  <i class="fa-solid" :class="trackIcon(index)" aria-hidden="true" />
                </div>
                <div class="node-name">
                  {{ tierLabel(vip.name) }}
                </div>
                <div class="node-range">
                  {{ tierRange(vip.name) }}
                </div>
              </div>
            </div>
          </div>

          <div class="vip2-cards-wrap">
            <button type="button" class="vip2-arrow vip2-arrow-prev" aria-label="上一個" @click="scrollCards('prev')">
              <i class="fa-solid fa-chevron-left" aria-hidden="true" />
            </button>
            <div ref="vip2Cards" class="vip2-cards">
              <div v-for="(vip, index) in bVipList" :key="vip.id || index" class="vip2-card">
                <span class="card-badge">{{ vip.name }}</span>
                <p class="card-amount">
                  {{ vip.amount }}
                </p>
                <p class="card-amount-label">
                  {{ $t('Bao.total_bet_amount') }}
                </p>
                <ul class="vip2-benefits">
                  <li v-for="(benefit, bi) in vip.benefits" :key="bi">
                    <span class="b-check"><i class="fa-solid fa-check" aria-hidden="true" /></span>{{ benefit }}
                  </li>
                </ul>
              </div>
            </div>
            <button type="button" class="vip2-arrow vip2-arrow-next" aria-label="下一個" @click="scrollCards('next')">
              <i class="fa-solid fa-chevron-right" aria-hidden="true" />
            </button>
          </div>
        </div>

        <!-- eslint-disable-next-line -->
        <div v-if="vipRule" class="vip2-desc" v-html="vipRule"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { page } from '@/api/common'
import { getAllVipInfo, getAllSpecialVipInfo, getRebateInfo } from '@/api/vip'
import { showNotice } from '@/utils/tool'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'
import '@/assets/css/vip.css'
import '@/assets/css/vip2.css'

export default {
  mixins: [themeMixin],
  data() {
    return {
      allVipInfo: [],
      rebateInfo: [],
      litePlayer: null,
      currentVipLevel: 1,
      selectedVip: {
        key: 0,
        upgrade_prize: 0, // 升級獎勵
        keep_bet_amount_text: 0 // 保級流水
      },
      spec_icon_show: {
        upgrade_money: true,
        monthly_prize: true,
        birthday_prize: true
      },
      // 階段型 VIP 進度軸節點 icon
      trackIcons: [
        'fa-medal', 'fa-award', 'fa-star', 'fa-crown', 'fa-gem',
        'fa-chess-king', 'fa-chess-queen', 'fa-trophy', 'fa-dragon', 'fa-skull'
      ],
      vipRule: ''
    }
  },
  computed: {
    ...mapGetters(['token', 'user']),
    vipInfo() {
      return this.user.vipInfo
    },
    // 既有 vip_levels（無 multiple_data / benefits）
    aVipList() {
      return this.allVipInfo.filter(vip => !this.isStagedVip(vip))
    },
    // 階段型 VIP（具 multiple_data 或 benefits 陣列）
    bVipList() {
      return this.allVipInfo.filter(vip => this.isStagedVip(vip))
    },
    // 使用者目前所在的 B 階段在 bVipList 的 index
    // 以 tier 名稱（"Lv." 之前）比對 vipInfo.currentVipName，取最長相符者（避免 Master 誤中 Grand Master）
    currentStagedTierIndex() {
      const current = String((this.vipInfo && this.vipInfo.currentVipName) || '').toLowerCase()
      if (!current) return 0
      let best = -1
      let bestLen = 0
      this.bVipList.forEach((vip, i) => {
        const label = this.tierLabel(vip.name).toLowerCase()
        if (label && current.indexOf(label) > -1 && label.length > bestLen) {
          best = i
          bestLen = label.length
        }
      })
      return best >= 0 ? best : 0
    },
    cumulative_flow() {
      const amount = this.vipInfo.upgradeNeedPerformance - this.vipInfo.upgradeCurrentPerformance
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return 0
      }
    },
    upgrade_performance_percentage() {
      const percentage = parseInt(this.vipInfo.upgradeCurrentPerformance) / parseInt(this.vipInfo.upgradeNeedPerformance) * 100
      return percentage > 100 ? 100 : percentage
    },
    currentVipName() {
      if (this.bVipList.length > 0) {
        return ''
      }
      if (!this.user ||
          !this.vipInfo ||
          !this.litePlayer) {
        return ''
      }

      const matchNum = this.vipInfo.currentVipName.match(/VIP(\d+)/)
      const matchChar = this.rebateInfo.find(array => array[0] === this.vipInfo.currentVipName)

      if (matchNum) {
        const level = matchNum[1]
        let result = `VIP${level}`
        if (!level) {
          result = 'VIP9'
        }
        this.scrollToHighlighted()
        return result
      }

      if (matchChar) {
        this.scrollToHighlighted()
        return matchChar[0]
      }

      return ''
    },
    tableData() {
      const isShow = false
      const data = [
        {
          label: 'Bao.upgrade_prize_text',
          key: 'upgrade_prize'
        },
        {
          label: 'Bao.birthday_prize_text',
          key: 'birthday_prize'
        },
        {
          label: 'Bao.upgrade_bet_amount_text',
          key: 'upgrade_bet_amount'
        },
        {
          label: 'Bao.upgrade_deposit',
          key: 'upgrade_deposit'
        }]

      if (isShow) {
        data.push({
          label: 'Bao.keep_bet_amount',
          key: 'keep_bet_amount'
        })
      }
      return data
    }
  },
  created() {
    getAllVipInfo()
      .then((response) => {
        this.allVipInfo = response.data.data

        this.setCurrentVipLevel()
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
    getAllSpecialVipInfo()
      .then((response) => {
        this.litePlayer = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })

    const timestamp = Date.now()
    page({ type: 'vip_rule', timestamp: timestamp }).then(response => {
      this.vipRule = response.data.data.content
    })
    this.scrollToHighlighted()
  },
  mounted() {
    getRebateInfo({ reverse_data: false })
      .then((response) => {
        this.rebateInfo = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
  },
  methods: {
    // 是否為階段型 VIP
    isStagedVip(vip) {
      return !!(vip && (vip.multiple_data || Array.isArray(vip.benefits)))
    },
    // tier 卡片列左右捲動（單張卡寬 320 + gap）
    scrollCards(direction) {
      const el = this.$refs.vip2Cards
      if (!el) return
      const step = 336
      el.scrollBy({ left: direction === 'prev' ? -step : step, behavior: 'smooth' })
    },
    // 進度軸節點 icon：依 index 依序對應，超過清單長度則循環
    trackIcon(index) {
      return this.trackIcons[index % this.trackIcons.length]
    },
    // 進度軸節點分組 tg-1~tg-4：依節點位置均分四組
    trackTierGroup(index, total) {
      if (!total) return 1
      return Math.min(4, Math.floor((index / total) * 4) + 1)
    },
    // 從階段名稱（例："Bronze Lv.1–30"）切出名稱部分（"Lv." 之前）
    tierLabel(name) {
      if (!name) return ''
      return String(name).replace(/\s*Lv\..*$/i, '').trim()
    },
    // 從階段名稱切出等級範圍部分（"Lv." 起，例："Lv.1–30"）
    tierRange(name) {
      if (!name) return ''
      const match = String(name).match(/Lv\..*$/i)
      return match ? match[0].trim() : ''
    },
    formatNumber(value) {
      if (value === null || value === undefined) return ''
      return Number(value).toLocaleString()
    },
    hasDailyMaxWin(vip) {
      return Array.isArray(vip.daily_max_win_text) && vip.daily_max_win_text.some(item => item.enable === 1)
    },
    getDailyMaxWinText(vip, gameTypeId) {
      if (!Array.isArray(vip.daily_max_win_text)) return ''
      const found = vip.daily_max_win_text.find(item => item.game_type_id === gameTypeId && item.enable === 1)
      return found ? found.text : ''
    },
    formatRebateText(value) {
      if (value === null || value === undefined || value === '') return ''
      // 若為純數字(含小數)且數值不超過 100 則加上 %,否則直接顯示原字串
      const str = String(value).trim()
      if (!/^-?\d+(\.\d+)?$/.test(str)) return str
      return Number(str) > 100 ? Number(str).toLocaleString() : `${str}%`
    },
    scrollToHighlighted() {
      this.$nextTick(() => {
        setTimeout(() => {
          const highlightedItem = this.$el.querySelector('.vvip-card.active')
          if (highlightedItem) {
            highlightedItem.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 700)
      })
    },
    setCurrentVipLevel() {
      if (!this.user ||
          !this.vipInfo) {
        return
      }

      for (const i in this.allVipInfo) {
        if (this.vipInfo.currentVipName === this.allVipInfo[i].level_name) {
          this.currentVipLevel = this.allVipInfo[i].level

          this.selectedVip = {
            key: i,
            upgrade_prize: this.allVipInfo[i].upgrade_prize,
            keep_bet_amount_text: this.allVipInfo[i].keep_bet_amount_text
          }
          this.setCurrentVipSpecIcon(this.allVipInfo[i].spec_icon_show)
        }
      }
    },
    setCurrentVipSpecIcon(select_spec_icon_show) {
      if (select_spec_icon_show) {
        this.spec_icon_show.upgrade_money = (select_spec_icon_show.indexOf('upgrade_money') > -1)
        this.spec_icon_show.monthly_prize = (select_spec_icon_show.indexOf('monthly_prize') > -1)
        this.spec_icon_show.birthday_prize = (select_spec_icon_show.indexOf('birthday_prize') > -1)
      } else {
        this.spec_icon_show = {
          upgrade_money: false,
          monthly_prize: false,
          birthday_prize: false
        }
      }
    }
  }
}
</script>

